import { render, staticRenderFns } from "./MutationAddEdit.vue?vue&type=template&id=2bb0f846"
import script from "./MutationAddEdit.vue?vue&type=script&lang=js"
export * from "./MutationAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports